const initialState = [];

function zonesReducer(state = initialState, action) {
  switch (action.type) {
    case "zones/update":
      return action.payload;
    case "zones/delete":
      return state.filter((zone) => !action.payload.includes(zone.id));
    case "zones/add":
      return [...state, action.payload];
    case "zones/updateOne":
      return state.map((zone) =>
        zone.id === action.payload.id ? { ...zone, ...action.payload } : zone
      );
    default:
      return state;
  }
}

export default zonesReducer;
